/**
 * Global Color Codes to be used outside of SCSS.
 * Can make sass classes also out of these.
 */
export class GlobalColorCodes {
  static readonly severityError = '#EF4444';
  static readonly severityYellow = '#FFCD32';
  static readonly severityGreen = '#609E5B';
}
